import { Component, OnInit } from '@angular/core';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
    selector: 'app-tls-solution',
    templateUrl: './tls-solution.component.html',
    styleUrls: ['./tls-solution.component.scss'],
    standalone: false
})
export class TlsSolutionComponent implements OnInit {
  Images = IMAGES;
  constructor() { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });

  }

}
